import React from "react";
import { useTranslation } from "react-i18next";

import Select from "../Select";

const YesNo = (props) => {
  const { t } = useTranslation();

  return (
    <Select {...props}>
      <Select.Option value={true}>{t("Yes")}</Select.Option>
      <Select.Option value={false}>{t("No")}</Select.Option>
    </Select>
  );
};

YesNo.propTypes = Select.propTypes;
YesNo.defaultProps = Select.defaultProps;

export default YesNo;
